import { axiosInstance } from "../../../../Services";

export const fetchCardWorklogs = async (cardId) => {
    try {
      const res = await axiosInstance.get(`/mmhboard/cards/worklog/${cardId}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
  
  export const addCardWorklog = async (cardId, formData) => {
    try {
      const res = await axiosInstance.post(
        `/mmhboard/cards/worklog/${cardId}`,
        formData,
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  